import { HTTP } from '../../http-common'

export default {
  state: {
    loadedBatchStates: []
  },
  getters: {
    loadedBatchStates (state) {
      return state.loadedBatchStates
    }
  },
  mutations: {
    setLoadedBatchStates (state, payload) {
      state.loadedBatchStates = payload
    },
    createBatchState (state, payload) {
      state.loadedBatchStates.push(payload)
    },
    updateBatchState (state, payload) {
      state.loadedBatchStates = state.loadedBatchStates.map(batchState => batchState.id === payload.id ? payload : batchState)
    },
    removeBatchState (state, id) {
      state.loadedBatchStates = state.loadedBatchStates.filter(batchState => {
        return batchState.id !== id
      })
    },
    clearLoadedBatchStates (state) {
      state.loadedBatchStates = []
    }
  },
  actions: {
    loadBatchStates ({ commit }) {
      commit('clearError')
      commit('setLoading', true)
      commit('setLoadedBatchStates', [])

      return new Promise((resolve, reject) => {
        HTTP.get('batch_states.json')
          .then(result => {
            console.log(result.data)
            commit('setLoadedBatchStates', result.data.results)
            resolve(result.data)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    createBatchState ({ commit, getters }, payload) {
      console.log('createBatchState')
      commit('clearError')
      commit('setLoading', true)
      const newBatchState = {
        description: payload.description
      }
      return new Promise((resolve, reject) => {
        HTTP.post('batch_states.json/', newBatchState)
          .then(result => {
            console.log(result)
            commit('createBatchState', result.data)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    updateBatchState ({ commit, getters }, payload) {
      console.log('updateBatchState')
      commit('clearError')
      commit('setLoading', true)
      const batchState = {
        description: payload.description
      }
      return new Promise((resolve, reject) => {
        HTTP.patch(`batch_states.json/${payload.id}/`, batchState)
          .then(result => {
            console.log(result)
            commit('updateBatchState', result.data)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    removeBatchState ({ commit }, payload) {
      console.log('removeBatchState')
      commit('clearError')
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        HTTP.delete(`batch_states.json/${payload}`)
          .then(result => {
            console.log('result', result)
            commit('removeBatchState', payload)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    clearLoadedBatchStates ({ commit }) {
      commit('clearLoadedBatchStates')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/batch_state/index.js